module.exports = __webpack_public_path__ + "product-bg.png?083ed58e604c93595bd105c4bba95844";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-bg.png
// module id = 44
// module chunks = 0